import React, { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import actionCreators from "../../../store/Auth/actionCreators";
import { BeatLoader } from "react-spinners";
import { redirectUri } from "../../../common/services/saml";
import { useHistory } from "react-router-dom";

const AuthorisePage: FC = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        const validate = async () => {
            const URLSearchParams = require("url-search-params");
            const queryParams = new URLSearchParams(location.search);

            const stateSaved = localStorage.getItem("lshf_auth_state");
            const codeVerifierSaved = localStorage.getItem("lshf_auth_code_verifier");

            if (
                !queryParams.get("code") ||
                !queryParams.get("state") ||
                queryParams.get("state") !== stateSaved ||
                !codeVerifierSaved
            ) {
                localStorage.removeItem("lshf_auth_state");
                localStorage.removeItem("lshf_auth_code_verifier");
                dispatch(
                    actionCreators.errorResponse.create(
                        "Authentication failed - an unexpected error occurred"
                    )
                );
                history.push("/welcome");
            } else {
                dispatch(
                    actionCreators.samlValidate.create(
                        JSON.stringify({
                            code: queryParams.get("code"),
                            codeVerifier: codeVerifierSaved,
                            redirectUri: redirectUri,
                            state: queryParams.get("state"),
                        })
                    )
                );
            }
        };

        validate();
    }, []);

    return (
        <div className="loading">
            <BeatLoader color={"#ffffff"} width={"70px"} />
        </div>
    );
};

export default AuthorisePage;
